const infoManual = `
　当該施設・事業に在籍している加入要件を満たす職員は全て登録してください。`;
const infoManualTwo = `　「兼務職員ヘルプマーク②」及び「加入要件を満たさない職員」のみの施設・事業であり、加入登録する職員数が「0名」となる施設・事業については、そのまま画面下部にある「以下に該当する職員はすべて登録しました」に☑を入れ、「登録完了」ボタンを押してください。`;

const infoManualThree = `　他の施設から配置換えとなる職員については、「配置換え登録」ボタンより職員を登録し、「修正」ボタンを押して本俸月額、従業状況を更新してください。<
　施設に在籍している加入対象の職員をまとめて一括で登録する場合には、「職員情報登録様式のダウンロード」ボタンを押して、
様式をダウンロード、入力のうえ、「職員情報登録様式のアップデート」ボタンを押して、登録してください。`;

const stepperData = ["施設情報・職員情報", "届出内容確認", "機構へ提出"];
const tableHeadList = [
  {
    headTitle: "職員氏名",
    width: "25%",
  },
  {
    headTitle: "生年月日",
    width: "10%",
  },
  {
    headTitle: "性別",
    width: "5%",
  },
  {
    headTitle: "加入資格",
    width: "10%",
  },
  {
    headTitle: "俸給額",
    width: "10%",
  },
  {
    headTitle: "俸給の調整額",
    width: "10%",
  },
  {
    headTitle: "職員の更新",
    width: "10%",
  },
  {
    headTitle: "雇用契約書の写し",
    width: "20%",
  },
];

export {
  stepperData,
  tableHeadList,
  infoManual,
  infoManualTwo,
  infoManualThree,
};
